import { Typography } from "@mui/material";
import styles from "./TakeAssessmentInfo.module.css";
import i18n from "../../../../i18n";
import { baseTransKey } from "../takeAssessmentHelper";

function TakeAssessmentHeader({ children }: { children: React.ReactNode }) {
	return (
		<Typography className={styles.takeAssessmentHeader} variant="h2">
			{children}
		</Typography>
	);
}

function TakeAssessmentDescription({ children }: { children: React.ReactNode }) {
	return <Typography className={styles.takeAssessmentDesc}>{children}</Typography>;
}

type TakeAssessmentLabelWrapperProps = {
	title: React.ReactNode;
	description: React.ReactNode;
};

function TakeAssessmentLabelWrapper({ title, description }: TakeAssessmentLabelWrapperProps) {
	return (
		<div className={styles.takeAssessmentLabelWrapper}>
			<TakeAssessmentHeader>{title}</TakeAssessmentHeader>
			<TakeAssessmentDescription>{description}</TakeAssessmentDescription>
		</div>
	);
}

type TakeAssessmentInfoProps = {
	quizName: string;
	courseName?: string;
	description?: string;
};

export default function TakeAssessmentInfo({ quizName, courseName, description }: TakeAssessmentInfoProps) {
	return (
		<div className={styles.quizInfoContainer}>
			<TakeAssessmentLabelWrapper title={i18n.t(`${baseTransKey}.assessment`)} description={quizName} />
			{courseName && (
				<>
					<TakeAssessmentLabelWrapper title={i18n.t(`${baseTransKey}.course`)} description={courseName} />
				</>
			)}
			{description && (
				<>
					<TakeAssessmentLabelWrapper title={i18n.t(`${baseTransKey}.details`)} description={description} />
				</>
			)}
		</div>
	);
}
